import React, { useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Form, Select } from 'antd'
import { map } from 'lodash-es'

import {
  createUrl,
  getQueryParams,
} from '../../core/utils/services/queryParams'

import { BRAND_RANKS } from '../../brands/constants'
import { DEFAULT_PAGE } from '../constants'

const BrandRankFilter = () => {
  const history = useHistory()
  const { pathname, search } = useLocation()

  const { brandRank } = getQueryParams(search)

  const handleChange = useCallback(
    brandRank =>
      history.push(
        createUrl(pathname, search, {
          brandRank,
          page: DEFAULT_PAGE,
        }),
      ),
    [history, pathname, search],
  )

  return (
    <Form.Item label="Brand rank">
      <Select
        style={{ width: '100%' }}
        value={brandRank}
        onChange={handleChange}
        allowClear
      >
        {map(BRAND_RANKS, ({ name, value }) => (
          <Select.Option key={value} value={value}>
            {name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default BrandRankFilter
